import { useContext, useEffect } from 'react'
import Header from '../components/headerComponent/Header';
import Sidebar from '../components/sidebarComponent/Sidebar';
import { Outlet, useNavigate } from 'react-router-dom';
import { AppContext, appStore } from '../context/AppContext';
import audio from '/audio/notification-sound.wav';

export default function Layout(props) {
    
    let myaudio = new Audio(audio);
    let updateNotifCount = appStore(state => state.increaseCount);
    let updateDashboard = appStore(state => state.updateDashboardData);
    let tokenData = useContext(AppContext);
    const navigate = useNavigate();
    const client = appStore(state => state.sClient);

    useEffect(() => {
        
        if (client?.current?.connected) {
            
        const sub = client.current.subscribe(`/topic/notification/${tokenData.userID}`, (message) => {
            //console.log("notification",message);
            updateNotifCount();
            myaudio.play();
        });

        // const sub1 = client.current.subscribe(`/topic/frontend/lora/sanarapida/data`, (message) => {
        //     console.log("lora",message);
        //     debugger;
        // });
            
        }
        else{
            console.log("NOt connected");
        }
        
        if(window.location.pathname === '/')
            navigate('/dashboard');

    }, []);

  return (
    <>
        <div style={{height: '9vh'}}>
            <Header />
        </div>

        <div style={{height:'91vh', display:'flex', flexDirection:'row'}}>
            <div style={{flex: '0.1'}}>
                <Sidebar menuOptions={props.menu}/>
            </div>
            <div className='main-card-div' style={{flex: 1}}>
                
                <Outlet />
                
                
            </div>
            <input type='hidden' defaultValue={0} id="oldFacility" />
        </div>


    </>
    
  )
}
